import { createTheme } from "@mui/material";
import { ObjType } from "../entity/BaseEntity";
import generatedGitInfo from '../generatedGitInfo.json';

/**
 * 定数
 */
namespace Constants {
  /***************************************************************
   * セッション管理
   **************************************************************/
  export const SESSION_MAX_ARG = 3600; // 60*60 60分
  export const NAVI_FORBIDDEN = "/forbidden"; // 許可されていないページ
  export const NAVI_LOGIN = "/";  // ログイン
  // export const NAVI_MFA = "/twostep_auth"; // MFA画面
  export const NAVI_TOP = "/contract"; // トップ画面

  export const LOGIN_TOKEN_KEY = "adminSecKey";

  /***************************************************************
   * 権限
   **************************************************************/

  // メニュー
  export const AUTH_TENANT = "TENANT";
  export const AUTH_CONTRACT = "CONTRACT";
  export const AUTH_CONTRACT_USER = "CONTRACT_USER";

  // テナント
  export const AUTH_TENANT_CREATE = "TENANT_CREATE";
  export const AUTH_TENANT_DELETE = "TENANT_DELETE";
  export const AUTH_TENANT_DETAIL = "TENANT_DETAIL";
  export const AUTH_TENANT_EDIT = "TENANT_EDIT";

  // 契約
  export const AUTH_CONTRACT_CREATE = "CONTRACT_CREATE";
  export const AUTH_CONTRACT_DELETE = "CONTRACT_DELETE";
  export const AUTH_CONTRACT_DETAIL = "CONTRACT_DETAIL";
  export const AUTH_CONTRACT_EDIT = "CONTRACT_EDIT";

  // 契約管理ユーザー
  export const AUTH_CONTRACT_USER_CREATE = "CONTRACT_USER_CREATE";
  export const AUTH_CONTRACT_USER_DELETE = "CONTRACT_USER_DELETE";
  export const AUTH_CONTRACT_USER_DETAIL = "CONTRACT_USER_DETAIL";
  export const AUTH_CONTRACT_USER_EDIT = "CONTRACT_USER_EDIT";

  // 企業
  export const AUTH_COMPANY_CREATE = "COMPANY_CREATE";
  export const AUTH_COMPANY_DELETE = "COMPANY_DELETE";
  export const AUTH_COMPANY_DETAIL = "COMPANY_DETAIL";
  export const AUTH_COMPANY_EDIT = "COMPANY_EDIT";

  // MDMユーザー
  export const AUTH_MDM_USER_CREATE = "MDM_USER_CREATE";
  export const AUTH_MDM_USER_DELETE = "MDM_USER_DELETE";
  export const AUTH_MDM_USER_DETAIL = "MDM_USER_DETAIL";
  export const AUTH_MDM_USER_EDIT = "MDM_USER_EDIT";


  /***************************************************************
   * エラー
   **************************************************************/
  export const ERR_STATUS_OK = "OK";
  export const ERR_STATUS_NG = "NG";
  export const ERR_STATUS_INVALID = "INVALID";
  export const ERR_CODE_204 = "204";
  export const ERR_CODE_404 = "404";
  export const ERR_CODE_500 = "500";

  /***************************************************************
   * メッセージコード
   **************************************************************/
  export const W_MSG_CODE_SESSION_TIMEOUT = "W-ADM-000-016";

  /***************************************************************
   * メッセージ
   **************************************************************/
  export const T_MSG_NO_DATA = "DATA NOT FOUND";
  export const W_MSG_NO_DATA = "該当のデータは見つかりません。";
  export const E_MSG_SYSTEM_ERR = "システムエラーが発生しました。";

  /***************************************************************
   * モード
   **************************************************************/
  export const MODE: ObjType = {
    EDIT: "保存",
    DELETE: "削除",
    CANCEL: "キャンセル",
    CHANGE: "変更",
    ACT: "実行",
  };

  /***************************************************************
   * ヘッダー
   **************************************************************/
  export const HEADER_HEIGHT = "64px";

  /***************************************************************
   * フッター
   **************************************************************/
  export const APPLICATION_VERSION = generatedGitInfo.commitId;
  export const COMPANY_LOGO = "/images/common/company_logo.jpg";
  export const COMPANY_LOGO_URL = "https://www.fsi.co.jp";
  export const COPYRIGHT = "©2023 FUJISOFT INCORPORATED";

  /***************************************************************
   * 全体
   **************************************************************/
  // 全体のテーマ
  export const DEFAULT_THEME = createTheme({
    palette: {
      primary: {
        main: "#004499"
      },
    },
  });

}

export default Constants;
